import * as React from "react"
import {ToggleButtonSeeker} from "@ui-seeker/core";

import { authorizedSeller } from "@signals"


export default function DIPAuthorizedSeller() {
    return <ToggleButtonSeeker
		value={authorizedSeller.value ? 'YES' : 'NO'}
		tabs={[
			{ value: 'NO', label: 'All sellers' },
			{ value: 'YES', label: 'Authorized sellers' },
		]}
		onChange={(_, newValue) => authorizedSeller.value = newValue === 'YES'}
	/>
}